// @flow

import omit from 'lodash/omit';
import get from 'lodash/get';
import createApiClient from 'src/modules/seek-jobs-api-client';
import { LOCATION_CHANGED } from 'src/store/location/location';

const api = createApiClient();

export const GET_LMIS_SUCCESS = 'GET_LMIS_SUCCESS';
export const GET_LMIS_ERROR = 'GET_LMIS_ERROR';
export const LMIS_IMPRESSION = 'LMIS_IMPRESSION';

const omittedlmisSearchParams = [
  'page',
  'advertiserid',
  'advertisergroup',
  'sortmode',
  'daterange'
];

type State = {
  content: string,
  lmisType?: string,
  lmisContextType?: string
};

type Actions =
  | typeof GET_LMIS_SUCCESS
  | typeof GET_LMIS_ERROR
  | typeof LOCATION_CHANGED;

type Action = {
  type: Actions,
  payload: {
    content?: string,
    lmisType?: string,
    lmisContextType?: string
  }
};

const initialState = {
  content: '',
  lmisType: 'fallback'
};

export const lmisImpression = ({
  lmisType,
  lmisContextType
}: {
  lmisType?: string,
  lmisContextType?: string
}) => ({
  type: LMIS_IMPRESSION,
  payload: { lmisType, lmisContextType }
});

let isFirstLocationChange = true;
export default function reducer(state: State = initialState, action: Action) {
  switch (action.type) {
    case GET_LMIS_SUCCESS: {
      const { content, lmisType, lmisContextType } = action.payload;

      return {
        ...state,
        content,
        lmisType,
        lmisContextType
      };
    }

    case LOCATION_CHANGED:
    case GET_LMIS_ERROR: {
      if (!isFirstLocationChange) {
        return {
          ...state,
          content: '',
          lmisType: 'fallback',
          lmisContextType: 'fallback'
        };
      }
      isFirstLocationChange = false;
      return state;
    }

    default:
      return state;
  }
}

export const getSerpLmis = ({
  requestId,
  placement = '90ae91'
}: {
  requestId: string,
  placement?: string
}) => (dispatch: Function, getState: Function) => {
  const { search, location, user } = getState();

  const searchParams = omit(search.query, omittedlmisSearchParams);

  const lmisParams = {
    placement,
    location: location.locale,
    loggedin: user.authenticated,
    ...searchParams
  };

  return api.lmis
    .getLmis({ lmisParams, requestId })
    .then(response => {
      return dispatch({
        type: GET_LMIS_SUCCESS,
        payload: response
      });
    })
    .catch(err => {
      return dispatch({
        type: GET_LMIS_ERROR,
        payload: {
          err
        }
      });
    });
};

export const getJobDetailLmis = (options: {
  placement?: string,
  requestId: string
}) => (dispatch: Function, getState: Function) => {
  const { placement = '70ea71', requestId } = options;
  const { location, user, jobdetails } = getState();

  const classification = get(jobdetails, 'result.classification.id', '');

  const lmisParams = {
    placement,
    location: location.locale,
    loggedin: user.authenticated,
    classification,
    roleId: get(jobdetails, 'result.roleTitles')
  };

  return api.lmis
    .getLmis({ lmisParams, requestId })
    .then(response => {
      return dispatch({
        type: GET_LMIS_SUCCESS,
        payload: response
      });
    })
    .catch(err => {
      return dispatch({
        type: GET_LMIS_ERROR,
        payload: {
          err
        }
      });
    });
};
